import { Component, Input } from '@angular/core';

@Component({
  selector: 'profile-badge',
  templateUrl: './profile-badge.component.html',
  standalone: false,
})
export class ProfileBadgeComponent {
  @Input() image: string;

  @Input() numberOfNotifications: number = 0;

  get hasImage(): boolean {
    return !!this.image;
  }

  get displayBadgeContent(): boolean {
    return !!this.numberOfNotifications && this.numberOfNotifications > 0;
  }

  get contentNumber(): string {
    if (this.numberOfNotifications > 99) {
      return '99+';
    }
    return this.numberOfNotifications.toString();
  }
}
